import { useApolloClient } from '@apollo/react-hooks';
import { FETCH_COMPETITIONS } from '../GraphQL/Queries';
import logger from '../logger';

const useUpdateCompetitionsCache = (tenantId, categoryId) => {
  const client = useApolloClient();
  const updateCache = (competition) => {
    try {
      const data = client.readQuery({
        query: FETCH_COMPETITIONS,
        variables: {
          tenantId,
          categoryId,
        },
      });
      client.writeQuery({
        query: FETCH_COMPETITIONS,
        data: {
          fetchCompetitions: [
            ...data.fetchCompetitions,
            { ...competition },
          ],
        },
        variables: {
          tenantId,
          categoryId,
        },
      });
    } catch (e_) {
      logger('Update not needed!');
    }
  };

  return updateCache;
};

export default useUpdateCompetitionsCache;
